var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.clsx('big-logo', { 'animations-disabled': !_vm.animationEnabled })},[_c('img',{staticClass:"logo",attrs:{"src":"/images/promo/hero-section/big-logo.svg","alt":"UConnect logo"}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }